import { IonIcon } from '@ionic/react'
import { createOutline } from 'ionicons/icons'
import { myPalette } from '../theme'

export function MenuAppRegistrationIcon() {
  return (
    <div
      style={{
        padding: '8px',
        borderRadius: '100%',
        background: myPalette.midnightBlue.main,
        display: 'flex',
      }}
    >
      <IonIcon
        icon={createOutline}
        style={{
          color: myPalette.white.main,
          width: '20px',
          height: '20px',
        }}
      />
    </div>
  )
}
